<template>
  <div class="home">
    <!-- 背景 -->
    <div class="callback">
    </div>
    <!-- 内容 -->
    <div class="neirong">
      <div class="left1">
        <div class="txtss">
          <div class="first">北京心叶体育文化有限公司</div>
          <div class="sec">地址:北京市海淀区永润路18号院5幢-1层107-25</div>
          <div class="sec">网址:www.xytsn.com</div>
          <div class="sec">联系电话:13901052574,13260018419</div>
        </div>
        <div class="right">
          <div class="pt">
            <img class="sao" src="../../img/newewm.jpg" alt="">
            <div class="guan">扫一扫,关注公众号</div>
          </div>
        </div>
      </div>
      <!-- 地图 -->
      <div class="BaiDuMap">
                <baidu-map
                  :center="center"
                  :zoom="zoom"
                  :scroll-wheel-zoom="true"
                  style="width: 100%; height: 100%"
                  @ready="handler"
                  @click="getClickInfo"
                  @moving="syncCenterAndZoom"
                  @moveend="syncCenterAndZoom"
                  @zoomend="syncCenterAndZoom"
                >
                  <!-- 必须给容器指高度，不然地图将显示在一个高度为0的容器中，看不到 -->
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                  <bm-geolocation
                    anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                    :showAddressBar="true"
                    :autoLocation="true"
                  ></bm-geolocation>
                  <bm-marker :position="{lng: 116.238849, lat: 40.095056}" :dragging="false" >
                    <bm-label content="北京市海淀区永润路18号院5幢-1层107-25" :labelStyle="{color: 'red', fontSize : '14px'}" :offset="{width: -35, height: 30}"/>
                  </bm-marker>
                  <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                </baidu-map>
              </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: '1',
      backgroundColor: '',
      Activeindex: '0',
      arr: ['滑步车', '跳绳', '篮球', '体操', '田径', '跑酷'],
      // 地址信息
      address: null,
      center: { lng: 0, lat: 0 },
      // 地图展示级别
      zoom: 17
    }
  },
  methods: {
    //
    handler ({ BMap, map }) {
      this.center.lng = 116.238849
      this.center.lat = 40.095056
      // eslint-disable-next-line no-self-assign
      this.zoom = this.zoom
    },
    getClickInfo (e) {
      // 创建地理编码实例
      // eslint-disable-next-line no-undef
      const myGeo = new BMap.Geocoder()
      // 根据坐标逆解析地址
      // eslint-disable-next-line no-undef
      myGeo.getLocation(new BMap.Point(e.point.lng, e.point.lat), (result) => {
        console.log(result, 'result-->>>>')
        if (result) {
          this.address = result.address
        }
      })
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    },
    syncCenterAndZoom (e) {
      console.log(e.target, 'e.target-->>>>')
      // eslint-disable-next-line no-unused-vars
      const { lng, lat } = e.target.getCenter()
      this.zoom = e.target.getZoom()
    },
    //
    handleJump () {
      this.componentId = this.componentName[this.activeIndex]
      // this.$router.push('./trochlear')
    },
    activeHandle (index) {
    // 把我们自定义的下标赋值
      this.activeIndex = index
    },
    handleSelect (key, keyPath) {
      console.log(key, 'keykey')
      console.log(this.activeIndex, 'activeIndex')
      this.activeIndex = key
      console.log(key, keyPath)
    },
    index () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
body{
  margin: 0
}
/* 顶部 */
.top{
  height: 135px;
}
.logoimg{
  width: 1210px;
  height: 135px;
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.phone{
  display: flex;
}
.callme{
  padding-top: 5px;
  display: inline;
}
.callphone{
  font-weight: 700;
}
.call{
  font-size: 32px;
  font-weight: 700;
  color: #EB2F2F;
}
img{
  width: 180px;
  height: 135px;
}
.el-icon-phone{
    margin-top: 30px  ;
    font-size: 67px;
  }
/* tab */
.el-menu-demo{
  padding-left: 348px;
}
.tab{
  display: flex;
  height: 60px;
  background-color: pink;
}
.tabbox{
  width: 104px;
  height: 60px;
  background-color: skyblue;
}
.txt{
  font-size: 16px;
}
.txt01 {
    font-size: 16px;
    padding: 0 20px;
  }
:deep .el-submenu__title {
  padding: 0 !important;
}
.el-submenu__title{
  padding: 0 !important;
}
.active-background{
  background-color: red !important;
  color:#FFF!important;
}
/* 背景 */
.callback{
  width: 100%;
  height: 390px;
  background-image: url(../../img/联系我们背景图.jpg);
}
.title{
  height: 150px;
  font-size: 38px;
  padding-top: 40px;
  padding-bottom: 25px;
  text-align: center;
  color: #fff;
}
/* tab */
.taab{
  display: flex;
  height: 60px;
  padding-left: 348px;
  background-color: #A01C64;
}
.tabtxt{
  width: 100px;
  height: 60px;
  display: flex;
  justify-content: center;
  line-height: 60px;
  color: #FFF;
}
.active{
  color: red;
  border-bottom: 1px solid #000;
}
/* 内容 */
.neirong{
  width: 1100px;
  height: 800px;
  margin: 0 auto;
}
.first{
    font-size: 25px;
    color: red;
    padding: 40px 0 20px 0;
    text-align: left;
    font-weight: 700;
  }
.left1{
    display: flex;
    justify-content: space-between;
  }
  .sec{
    font-weight: 700;
    font-size: 18px;
    color: #333;
    margin:0 0 20px 0;
    text-align: left
  }
  .right1{
    display: flex;
    margin: 20px 20px 0 20px
  }
  .sao{
    width: 160px;
    height: 160px;
  }
  .guan{
    margin-left: 15px;
    font-weight: 700;

  }
  .pt{
    margin-top: 30px;
    margin-right: 40px;
  }
  .el-dropdown-link {
    font-size: 16px;
  }
  /* 地图 */
  .BaiDuMap {
  width: 800px ;
  height: 400px;
  margin-top: 50px;
  margin-left: 150px;
}
.my-button {
  /* 初始样式 */
  background-color: #eee;
  color: #333;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
}
.hover-color {
  /* 悬浮时的样式 */
  background-color: #eee2d1;

  color: #333;
}

</style>
